import axios from "axios";
import Config from "../config"
import { useLoginStore } from '../stores/login';
// const store = useLoginStore();

export default class CampaignService {
  constructor() {
    this.loginStore = null;
  }

  store() {
    if(!this.loginStore) { this.loginStore = useLoginStore(); };
    return this.loginStore;
  }

  async getCampaigns() {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      },
    }

    return await axios
      .get(
        Config.url("campaigns"),
        options
      ).then(res => { return res.data });
  }
  async getCampaignById(id) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };

    return await axios
      .get(
        Config.url("campaign")+"?campaignId="+id,
        options
      ).then(res => { return res.data });
  }
  async getListFirmware() {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };

    return await axios
      .get(
        Config.url("listFirmware"),
        options
      ).then(res => { return res.data });
  }
  async getCSV(id) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };

    return await axios
      .get(
        Config.url("csv").replace("{{campaignId}}",id),
        options
      ).then(res => { return res.data });
  }
  async createCampaign(values) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };

    return await axios
      .post(
        Config.url("createCampaign"),
        values,
        options
      ).then(res => { return res.data });
  }
  async deleteCampaign(id) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };
    return await axios
      .delete(
        Config.url("deleteCampaign") + "?campaignId=" + id,
        options
      ).then(res => { return res.data });
  }
  async stopCampaign(id) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };

    return await axios
      .post(
        Config.url("stopCampaign").replace("{{campaignId}}",id),
        {},
        options
      ).then(res => { return res.data });
  }
  async setSingleCampaign(data) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };

    return await axios
      .patch(
        Config.url("updateCampaign"),
        data,
        options
      ).then(res => { return res.data });
  }
  async getGoupForCampaign(data) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      },
    };
    return await axios
      .get(
        Config.url("groupsForCampaign") + "?campaignId=" + data.campaignId,
        options
      ).then(res => { return res.data });
  }
}